// Editable Product Links here
// var productLinks = {
//     '111': 'link-a-producto-espresso-2x250-mensual',
//     '112': 'link-a-producto-espresso-2x250-6meses',
//     '121': 'link-a-producto-espresso-4x250-mensual',
//     '122': 'link-a-producto-espresso-4x250-6meses',
//     '211': 'link-a-producto-filtro-2x250-mensual',
//     '212': 'link-a-producto-filtro-2x250-6meses',
//     '221': 'link-a-producto-filtro-4x250-mensual',
//     '222': 'link-a-producto-filtro-4x250-6meses',
//     '311': 'link-a-producto-mix-2x250-mensual',
//     '312': 'link-a-producto-mix-2x250-6meses',
//     '321': 'link-a-producto-mix-4x250-mensual',
//     '322': 'link-a-producto-mix-4x250-6meses'
// };

$("#subscription-button-proceed").on("click", function (event) {
  event.preventDefault(); // Prevent the default anchor behavior

  var productLink = $(this).attr("href"); // Get the href attribute value

  if (productLink) {
    window.open(productLink, "_blank"); // Open the link in a new tab
  }
});

var websiteHost = "https://" + jQuery(location).attr("hostname") + "/products/";

var selectedValues = {
  question1: "",
  question2: "",
  question3: "",
};

jQuery("#question-1").addClass("visible");

function scrollToElement(element) {
  $("html, body").animate(
    {
      scrollTop: $(element).offset().top - 20,
    },
    800
  );
}

$("#choice").on("click", function () {
  scrollToElement("#subscritiom-intro");
});

$(".subscription-answers .subscription-answer").on("click", function () {
  var $this = $(this);
  var questionNumber = $this.closest(".subscription-question").data("question");
  var answerValue = $this.index() + 1;

  selectedValues["question" + questionNumber] = answerValue;

  $this.siblings().removeClass("active");
  $this.addClass("active");

  if (questionNumber == 1 && selectedValues.question1) {
    $("#question-2").addClass("visible").fadeIn();
    scrollToElement("#question-2");
  } else if (questionNumber == 2 && selectedValues.question2) {
    $("#question-3").addClass("visible").fadeIn();
    scrollToElement("#question-3");
  }

  if (
    selectedValues.question1 &&
    selectedValues.question2 &&
    selectedValues.question3
  ) {
    var combinedValue =
      selectedValues.question1 +
      "" +
      selectedValues.question2 +
      "" +
      selectedValues.question3;
    var productLink = productLinks[combinedValue];

    if (productLink) {
      var fullUrl = websiteHost + productLink;
      $("#subscription-button-proceed").attr("href", fullUrl);
    }

    $(".proceed").addClass("visible").fadeIn();
    scrollToElement(".proceed");
  }
});

/* =========================================================
   DATA ANALYSIS - Subscription landing tracking
   Publishes events to Shopify Customer Events.
   Does NOT modify the subscription selector behaviour.
   ========================================================= */

(function ($) {
  var daSubscriptionSelections = {
    question1: "",
    question2: "",
    question3: "",
    question1_label: "",
    question2_label: "",
    question3_label: ""
  };

  function daPublishSubscriptionEvent(data) {
    try {
      if (
        window.Shopify &&
        Shopify.analytics &&
        typeof Shopify.analytics.publish === "function"
      ) {
        Shopify.analytics.publish("subscription_landing_click", data);
      }
    } catch (error) {
      console.warn("Subscription analytics event not published:", error);
    }
  }

  function daCurrentPath() {
    return window.location.pathname || "";
  }

  /* 1. CTA inicial: ¡ESCOGE! */
  $(document).on("click", "#choice", function () {
    daPublishSubscriptionEvent({
      interaction_type: "start",
      click_group: "subscription_cta",
      click_label: $.trim($(this).text()),
      step_name: "start",
      page_path: daCurrentPath()
    });
  });

  /* 2. Selecciones del funnel:
        Q1 = Espresso / Filtro / Combo
        Q2 = 2x250gr / 4x250gr
        Q3 = Mensual / Semestral
  */
  $(document).on(
    "click",
    ".subscription-answers .subscription-answer",
    function () {
      var $answer = $(this);
      var $question = $answer.closest(".subscription-question");

      var questionNumber = Number($question.data("question"));
      var optionValue = String($answer.data("value") || $answer.index() + 1);
      var optionLabel = $.trim($answer.find("h3").first().text());

      var stepNames = {
        1: "method",
        2: "quantity",
        3: "payment"
      };

      daSubscriptionSelections["question" + questionNumber] = optionValue;
      daSubscriptionSelections["question" + questionNumber + "_label"] =
        optionLabel;

      var scenario =
        daSubscriptionSelections.question1 +
        daSubscriptionSelections.question2 +
        daSubscriptionSelections.question3;

      daPublishSubscriptionEvent({
        interaction_type: "selection",
        click_group: "subscription_step",
        click_label: optionLabel,
        step_number: questionNumber,
        step_name: stepNames[questionNumber] || "",
        option_value: optionValue,
        scenario: scenario,
        method: daSubscriptionSelections.question1_label,
        quantity: daSubscriptionSelections.question2_label,
        payment: daSubscriptionSelections.question3_label,
        page_path: daCurrentPath()
      });
    }
  );

  /* 3. CTA final: ¡ME QUIERO SUSCRIBIR! */
  $(document).on("click", "#subscription-button-proceed", function () {
    var scenario =
      daSubscriptionSelections.question1 +
      daSubscriptionSelections.question2 +
      daSubscriptionSelections.question3;

    daPublishSubscriptionEvent({
      interaction_type: "proceed",
      click_group: "subscription_cta",
      click_label: $.trim($(this).text()),
      step_name: "proceed_to_product",
      destination_url: $(this).attr("href") || "",
      scenario: scenario,
      method: daSubscriptionSelections.question1_label,
      quantity: daSubscriptionSelections.question2_label,
      payment: daSubscriptionSelections.question3_label,
      page_path: daCurrentPath()
    });
  });

  /* 4. Salidas de la landing mediante enlaces:
        menú, Comprar café, FAQs, cafeterías, cursos, etc.
        Excluimos el CTA final porque ya se mide arriba.
  */
  $(document).on("click", "a", function () {
    if (!daCurrentPath().includes("/pages/suscripcion-hola-coffee")) {
      return;
    }

    if (this.id === "subscription-button-proceed") {
      return;
    }

    var href = $(this).attr("href") || "";

    if (!href || href === "#" || href.indexOf("javascript:") === 0) {
      return;
    }

    daPublishSubscriptionEvent({
      interaction_type: "navigation_exit",
      click_group: "navigation_exit",
      click_label: $.trim($(this).text()).replace(/\s+/g, " ").substring(0, 100),
      destination_url: href,
      page_path: daCurrentPath()
    });
  });
})(jQuery);